export default __webpack_public_path__ + "static/1-3ea79e49eda5a1a78465f4d788798fee.jpg";